import { operate } from '../util/lift';
import { OperatorSubscriber } from './OperatorSubscriber';
export function skip(count) {
    return operate(function (source, subscriber) {
        var seen = 0;
        source.subscribe(new OperatorSubscriber(subscriber, function (value) { return (count === seen ? subscriber.next(value) : seen++); }));
    });
}
//# sourceMappingURL=skip.js.map